import React, { Component } from 'react';

import classNames from 'classnames';
import { Dropzone } from 'components/dropzone';
import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';
import PropTypes from 'prop-types';

import BoxImageUploadActions from './BoxImageUploadActions';

import { UploadConsumer, UploadProptypes } from '@hotmart/club-files-ui';

import './BoxImageUpload.scss';

@UploadConsumer()
export default class BoxImageUpload extends Component {
  // #region setup
  static propTypes = {
    placeholderImg: PropTypes.func,
    fileUpload: UploadProptypes.fileUpload,
    value: PropTypes.object,
    sendFiles: PropTypes.func,
    token: PropTypes.string,
    uploaderId: PropTypes.string
  };

  get fileUpload() {
    return this.props.fileUpload;
  }

  shouldComponentUpdate(nextProps) {
    return (
      !isEqual(nextProps.value, this.props.value) ||
      !isEqual(nextProps.uploaderId, this.props.uploaderId)
    );
  }
  // #endregion

  render() {
    const {
      placeholderImg: PlaceholderImg,
      value: image,
      ...props
    } = this.props;

    let classComponent = 'box__image__upload';
    let onDrop = this.fileUpload && this.fileUpload.actions.sendMultiples;
    let Wrapper = Dropzone;

    if (!isEmpty(image)) {
      classComponent = classNames(
        classComponent,
        'dropzone box__image__upload--with-media'
      );
      onDrop = null;
      Wrapper = 'div';
    }

    return (
      <Wrapper className={classComponent} onDrop={onDrop}>
        <div className="dropzone__info">
          {PlaceholderImg && (
            <div className="dropzone__info__placeholder">
              <PlaceholderImg />
            </div>
          )}

          <BoxImageUploadActions
            placeholderImg={PlaceholderImg}
            image={image}
            {...props}
          />
        </div>
      </Wrapper>
    );
  }
}
